export default __webpack_public_path__ + "static/lamp-58e908fe5e04e7fe6b78d25338155a3c.webp";